<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import SvgIcon from '@/presentation/components/common/svg-icon/SvgIcon.vue';
import '@patsnap-ui/icon/assets/solid/export.svg';

const { t } = useI18n();
</script>

<template>
    <button
        class="th-btn th-btn-plain !pl-2"
    >
        <SvgIcon
            class="th-btn-icon mr-1 h-6 w-6 !text-grey-450"
            icon="SolidExport"
        />

        {{ t('aiDisclosureGlobal.globalBtn.export') }}
    </button>
</template>
